import { observer } from 'mobx-react-lite'

import { OwnerActivitiesTab } from '@/Containers/CrmSection/ActivityContainer/Hooks'

import type { CrmOwnerFormContextLike } from '../Owner/CrmOwnerFormContext'

export interface CrmActivitiesTabProps {
    /** Чия картка: клієнта чи перевізника */
    owner: 'client' | 'carrier'
    /** `formContext` картки власника — звідти `uuid`, `@id` і назва */
    ownerFormContext: CrmOwnerFormContextLike | undefined
    /** `full` — вкладка «Справи», `compact` — блок на «Загальному» */
    mode?: 'full' | 'compact'
}

/**
 * Вкладка «Справи» картки власника CRM (`SPEC-008` §3.4, §7.1;
 * `SPEC-011` §8.6) — каркас: вміст дає публічне API контейнера справ
 * (`ActivityContainer/Hooks`), а не прямий імпорт його компонентів.
 *
 * Власника читає з форми лише службове (`uuid`, `@id`) і назву — назва
 * потрібна, щоб у формі нової справи власник стояв підписаним, а не голим
 * `@id`. Значень, які редагують, вкладка не чіпає (`SPEC-002` §4.2).
 */
export const CrmActivitiesTab = observer(({ owner, ownerFormContext, mode = 'full' }: CrmActivitiesTabProps) => {
    const values = ownerFormContext?.values

    return (
        <OwnerActivitiesTab
            owner={owner}
            mode={mode}
            record={values ? { uuid: values.uuid, '@id': values['@id'], title: values['title'] } : undefined}
        />
    )
})
